import { useState } from "react";
import api from "@/lib/api";
import { Sparkles, CheckCircle2, XCircle } from "lucide-react";

export default function ATSOptimizer() {
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const analyze = async () => {
    if (!role.trim()) return;
    setLoading(true);
    try {
      const r = await api.post("/ats/analyze", { target_role: role });
      setResult(r.data);
    } catch (e) {
      alert(e.response?.data?.detail || "Analysis failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="space-y-6 max-w-5xl" data-testid="ats-page">
      <div className="jr-card">
        <div className="flex gap-3">
          <input value={role} onChange={(e) => setRole(e.target.value)} placeholder="Target role (e.g. Gen AI Engineer)"
            className="jr-input" data-testid="ats-role-input" />
          <button onClick={analyze} disabled={loading} className="jr-btn-primary" data-testid="ats-analyze-btn">
            <Sparkles className="w-4 h-4 inline mr-1" />
            {loading ? "Analyzing..." : "Analyze with AI"}
          </button>
        </div>
      </div>

      {result && (
        <div className="grid md:grid-cols-3 gap-4 jr-fade-in" data-testid="ats-result">
          <div className="jr-card md:col-span-1 text-center">
            <div className="text-zinc-400 text-xs mb-2">ATS Score</div>
            <div className="text-6xl font-bold text-emerald-300">{result.ats_score || 0}</div>
            <div className="text-zinc-300 mt-2">{result.verdict}</div>
            <div className="mt-4 text-xs text-zinc-400">Keywords: {result.keywords_found}/{result.keywords_total}</div>
          </div>
          <div className="jr-card md:col-span-2 space-y-3">
            <div className="grid grid-cols-3 gap-3 text-center">
              {["formatting", "structure", "readability"].map((k) => (
                <div key={k}>
                  <div className="text-xs text-zinc-400 capitalize">{k}</div>
                  <div className="text-lg font-semibold text-violet-200 mt-1">{result[k]}</div>
                </div>
              ))}
            </div>
            <div>
              <div className="text-zinc-400 text-xs mb-2">Missing Keywords</div>
              <div className="flex flex-wrap gap-1.5">
                {(result.missing_keywords || []).map((m) => (
                  <span key={m} className="jr-pill bg-rose-500/15 text-rose-200">{m}</span>
                ))}
              </div>
            </div>
            <div>
              <div className="text-zinc-400 text-xs mb-2">Improvements</div>
              <ul className="space-y-1 text-sm text-zinc-200">
                {(result.improvements || []).map((m, i) => (
                  <li key={`imp-${i}-${(m||'').slice(0,20)}`} className="flex gap-2"><CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />{m}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
